var tutorial = {};

tutorial.setup = function () {
  tutorial.pointerupImg = "tut-pointerup.png";
  tutorial.pointerdownImg = "tut-pointerdown.png";
  tutorial.thumbsupImg = "tut-thumbsup.png";
  tutorial.numOfSteps = 3;
  tutorial.currentStep = 0;
  tutorial.onComplete = gameScreen.updatePowerUps;
  tutorial.drags = [
    {
      start: gameScreen.getNumberPos(1, 1),
      end: gameScreen.getNumberPos(1, 2),
      img: "gem1.png",
    },
    {
      start: gameScreen.getNumberPos(2, 2),
      end: gameScreen.getNumberPos(1, 2),
      img: "gem2.png",
    },
    {
      start: gameScreen.getNumberPos(1, 2),
      end: gameScreen.getNumberPos(0, 2),
      img: "gem3.png",
    },
  ];
};

tutorial.draw = function (parent) {
  tutorial.setup();
  tutorial.handContainer = new Container(parent);
  tutorial.handContainer.alpha = 0;
  tutorial.handContainer.position = tutorial.drags[0].start;

  tutorial.objSprite = new Sprite(tutorial.handContainer, tutorial.drags[0].img);
  tutorial.objSprite.alpha = 0;

  tutorial.handSprite = new Sprite(tutorial.handContainer, tutorial.pointerupImg);
  tutorial.handSprite.position.set(20, 90);
  tutorial.handSprite.scale.set(0.75);

  tutorial.isDrawn = true;
  tutorial.resize();
};

tutorial.playStep = function () {
  TweenMax.killTweensOf(tutorial.handContainer);
  TweenMax.killTweensOf(tutorial.handSprite);
  clearInterval(tutorial.interval);
  if (tutorial.currentStep < tutorial.numOfSteps) {
    var duration = 0.5;
    var delay = 0.5;
    if (tutorial.currentStep == 0) {
      duration = 0.1;
      delay = 0.2;
    }
    tutorial.handSprite.texture = PIXI.utils.TextureCache[tutorial.pointerupImg];
    tutorial.objSprite.alpha = 0;
    TweenMax.to(tutorial.handContainer, duration, {
      pixi: {
        x: tutorial.drags[tutorial.currentStep].start.x,
        y: tutorial.drags[tutorial.currentStep].start.y,
        scale: 1,
        alpha: 1,
      },
      ease: Power2.easeInOut,
      delay: delay,
      onComplete: function () {
        var drag = function () {
          tutorial.handSprite.texture = PIXI.utils.TextureCache[tutorial.pointerdownImg];
          tutorial.objSprite.texture = PIXI.utils.TextureCache[tutorial.drags[tutorial.currentStep].img];
          tutorial.objSprite.alpha = 0.33;
          TweenMax.to(tutorial.handContainer, 0.2, {
            pixi: {
              scale: 0.9,
            },
            ease: Power2.easeOut,
          });
          TweenMax.to(tutorial.handContainer, 1.5, {
            pixi: {
              x: tutorial.drags[tutorial.currentStep].end.x,
              y: tutorial.drags[tutorial.currentStep].end.y,
            },
            ease: Power2.easeInOut,
            onComplete: function () {
              tutorial.handSprite.texture = PIXI.utils.TextureCache[tutorial.pointerupImg];
              tutorial.objSprite.alpha = 0;
            },
          });
          TweenMax.to(tutorial.handContainer, 0.5, {
            pixi: {
              x: tutorial.drags[tutorial.currentStep].start.x,
              y: tutorial.drags[tutorial.currentStep].start.y,
            },
            ease: Power2.easeInOut,
            delay: 2,
          });
          TweenMax.to(tutorial.handContainer, 0.2, {
            pixi: {
              scale: 1,
            },
            ease: Power2.easeOut,
            delay: 2,
          });
        };
        drag();
        tutorial.interval = setInterval(drag, 3100);
      },
    });
  }
  //thumbs up
  else {
    var mainDelay = 2;
    tutorial.objSprite.alpha = 0;

    TweenMax.to(tutorial.handContainer, 0.2, {
      pixi: {
        alpha: 0,
      },
    });

    TweenMax.to(tutorial.handContainer, 0.2, {
      pixi: {
        alpha: 1,
      },
      delay: mainDelay,
    });

    TweenMax.to(tutorial.handContainer, 0.7, {
      pixi: {
        x: 0,
        y: 0,
        scale: 1.5,
      },
      delay: mainDelay,
      ease: Power2.easeInOut,
    });

    TweenMax.to(tutorial.handContainer, 0.3, {
      pixi: {
        scale: 0.75,
        alpha: 0,
      },
      delay: mainDelay + 1.5,
      ease: Back.easeIn.config(1.7),
      onComplete: function () {
        tutorial.isDrawn = false;
        tutorial.handContainer.delete();
        saveObject("seenTutorial", true);
        if (tutorial.onComplete) {
          tutorial.onComplete();
        }
      },
    });

    TweenMax.to(tutorial.handSprite, 0.25, {
      pixi: {
        x: 0,
        y: 0,
        rotation: 45,
      },
      delay: mainDelay,
      ease: Power2.easeIn,
      onComplete: function () {
        tutorial.handSprite.texture = PIXI.utils.TextureCache[tutorial.thumbsupImg];
      },
    });
    TweenMax.to(tutorial.handSprite, 0.25, {
      pixi: {
        rotation: 90,
      },
      ease: Power2.easeOut,
      delay: mainDelay + 0.25,
    });
  }
};

tutorial.nextStep = function () {
  tutorial.currentStep++;
  tutorial.playStep();
};

tutorial.resize = function () {
  if (tutorial.isDrawn) {
    tutorial.handContainer.rotation = -tutorial.handContainer.parent.rotation;
  }
};

resize_methods.push(tutorial.resize);
